import { Box, Table } from '@mui/material';
import React from 'react';

const TableWrapper = ({
  height = 'calc(100vh - 250px)',
  children,
}: {
  height?: string;
  children: React.ReactNode;
}) => {
  return (
    <Box
      sx={{
        height,
        overflow: 'auto',
        position: 'relative',
        width: '100%',
      }}
    >
      <Table sx={{ borderCollapse: 'unset' }}>{children}</Table>
    </Box>
  );
};

export default TableWrapper;
